<template>
    <div>
        <div class="product-set__head">
            <div class="product-set__info">
                <h2 class="typo">
                    {{ title }}
                </h2>
                <p v-if="promotion.type !== 'Promo::Mix1'">
                    Zestaw #{{ index + 1 }} - Liczba punktów wywołujących
                    promocję:
                    <strong>{{ productsSet.required_weight }}</strong>
                </p>
            </div>
            <div class="form-group" v-if="showSetPrice">
                <label class="form-label">Cena zestawu</label>
                <span class="u-price"
                    >{{ (+productsSet.price).toFixed(2) }} zł</span
                >
            </div>
        </div>
        <div class="product-set__list">
            <div class="c-table">
                <div class="c-thead">
                    <div class="c-tw w-names">
                        <div class="c-td c-promos-image"></div>
                        <div class="c-td">Produkt</div>
                    </div>
                    <div
                        :class="{
                            'c-td text-right': promotion.type === 'Promo::Mix1',
                            'c-tw w-data': promotion.type !== 'Promo::Mix1'
                        }"
                    >
                        <div
                            :class="{
                                'c-td w-refund':
                                    promotion.type !== 'Promo::Mix1'
                            }"
                        >
                            Zwrot netto
                        </div>
                        <div
                            v-if="promotion.type !== 'Promo::Mix1'"
                            class="c-td w-points"
                        >
                            Punkty
                        </div>
                    </div>
                </div>
                <div class="c-tbody">
                    <promo-product
                        v-for="(product,
                        idx) in productsSet.product_set_dict_products"
                        :requiredWeight="productsSet.required_weight"
                        :isPromomix="true"
                        :isPromomix1="promotion.type === 'Promo::Mix1'"
                        :key="idx"
                        :product="product"
                    />
                </div>
            </div>
        </div>
        <div class="product-set__foot">
            <div class="product-list-legend">
                <p class="product-list-legend__title">
                    <a-icon icon="Info" />
                    <span>Dodatkowe wyjaśnienie</span>
                </p>
                <p v-if="$slots.additionalDescription">
                    <slot name="additionalDescription"></slot>
                </p>
                <p v-else-if="promotion.type === 'Promo::Mix1'">
                    Z puli
                    {{
                        productsSet.product_set_dict_products.length
                            | plurals('produktu', 'produktów')
                    }}
                    wybierz
                    <strong>{{
                        +productsSet.required_weight
                            | plurals(
                                'dowolną sztukę',
                                'dowolne sztuki',
                                'dowolnych sztuk'
                            )
                    }}</strong>
                </p>
                <p v-else>
                    Sumaryczna liczba punktów wybranych produktów musi
                    przekraczać
                    <strong>{{ productsSet.required_weight }}</strong
                    >. <br />Dopiero wtedy zostanie przyznana refundacja.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import PromoProduct from '@/components/promotions/PromoProduct'

export default {
    components: { PromoProduct },
    props: {
        showSetPrice: {
            type: Boolean,
            default: true
        },
        promotion: {
            type: Object,
            default: () => {}
        },
        productsSet: {
            type: Object,
            default: () => {}
        },
        index: {
            type: Number,
            default: 0
        },
        title: {
            type: String,
            default: 'Zestaw produktów promocyjnych'
        }
    }
}
</script>
